export const getDateIgnoreTimezone = (date) => {
    if(date && date.getUTCHours() !== 0)
    return ((theDate) =>
        new Date(theDate.getTime() - theDate.getTimezoneOffset() * 60 * 1000))(
         new Date(date)
        )
    else return date;
}